import React, { useState } from 'react';
import PasswordInput from './index';
const TogglePassword = ({ ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  return <PasswordInput showPassword={showPassword} handleClickShowPassword={handleClickShowPassword} {...rest} />;
};

export { TogglePassword };
